import { STATUS_ICON_CHECK_O, STATUS_ICON_LOADING, STATUS_ICON_TIMES_O, STATUS_ICON_INACTIVE } from '@/common/utils/statuses';
import computedLocale from '@/common/utils/computedLocale';
import i18n from '@/common/i18n';

export const DEPLOYMENT_STATUS = {
  DEPLOYING: 'deploying',
  DEPLOYED: 'deployed',
  COMPLETED: 'completed',
  FAILED: 'failed',
  CANCELLING: 'cancelling',
  CANCELLED: 'cancelled'
} as const;

export type DeploymentStatus = typeof DEPLOYMENT_STATUS[keyof typeof DEPLOYMENT_STATUS];

export const DEPLOYMENT_STATUS_TEXT = computedLocale<Record<DeploymentStatus, string>>(() => ({
  [DEPLOYMENT_STATUS.DEPLOYING]: i18n.t('Deploying'),
  [DEPLOYMENT_STATUS.DEPLOYED]: i18n.t('Deployed'),
  [DEPLOYMENT_STATUS.COMPLETED]: i18n.t('Completed'),
  [DEPLOYMENT_STATUS.FAILED]: i18n.t('Failed'),
  [DEPLOYMENT_STATUS.CANCELLING]: i18n.t('Canceling'),
  [DEPLOYMENT_STATUS.CANCELLED]: i18n.t('Cancelled')
}));

export const DEPLOYMENT_STATUS_ICON: Record<DeploymentStatus, string> = {
  [DEPLOYMENT_STATUS.DEPLOYING]: STATUS_ICON_LOADING,
  [DEPLOYMENT_STATUS.DEPLOYED]: STATUS_ICON_CHECK_O,
  [DEPLOYMENT_STATUS.COMPLETED]: STATUS_ICON_CHECK_O,
  [DEPLOYMENT_STATUS.FAILED]: STATUS_ICON_TIMES_O,
  [DEPLOYMENT_STATUS.CANCELLING]: STATUS_ICON_LOADING,
  [DEPLOYMENT_STATUS.CANCELLED]: STATUS_ICON_INACTIVE
};

export const DEPLOYMENT_STATUS_NORMALIZE: Record<string, DeploymentStatus> = {
  RUNNING: DEPLOYMENT_STATUS.DEPLOYING,
  [DEPLOYMENT_STATUS.DEPLOYING]: DEPLOYMENT_STATUS.DEPLOYING,
  DEPLOYED: DEPLOYMENT_STATUS.DEPLOYED,
  [DEPLOYMENT_STATUS.DEPLOYED]: DEPLOYMENT_STATUS.DEPLOYED,
  COMPLETED: DEPLOYMENT_STATUS.COMPLETED,
  [DEPLOYMENT_STATUS.COMPLETED]: DEPLOYMENT_STATUS.COMPLETED,
  ERROR: DEPLOYMENT_STATUS.FAILED,
  FAILED: DEPLOYMENT_STATUS.FAILED,
  [DEPLOYMENT_STATUS.FAILED]: DEPLOYMENT_STATUS.FAILED,
  CANCELLING: DEPLOYMENT_STATUS.CANCELLING,
  [DEPLOYMENT_STATUS.CANCELLING]: DEPLOYMENT_STATUS.CANCELLING,
  CANCELED: DEPLOYMENT_STATUS.CANCELLED,
  CANCELLED: DEPLOYMENT_STATUS.CANCELLED,
  [DEPLOYMENT_STATUS.CANCELLED]: DEPLOYMENT_STATUS.CANCELLED
};
